import { observer } from 'mobx-react'
import { useQuery } from 'react-query'
import { useHistory, useParams } from 'react-router'
import AppContainer from '../../../App/Container'
import { ReactComponent as ArrowLeft } from '../../../assets/images/icons/arrow-left.svg'
import { useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import RehypeRaw from 'rehype-raw'
import style from './InstructionDetailPage.module.css'

const InstructionDetailPage = observer(() => {
  const { push } = useHistory()
  const { slug } = useParams<{ slug: string }>()
  let article: any = null

  const { data, isLoading } = useQuery(
    ['instruction-details', slug],
    async () => {
      return await fetch(
        process.env.REACT_APP_STRAPI_URL + '/articles?_where[slug]=' + slug
      ).then(async (res) => await res.json())
    },
    {
      staleTime: 1_000_000,
      enabled: !!slug
    }
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (!isLoading && (data || []).length === 0) {
      push('/anleitung')
    }
  }, [isLoading])

  if (!isLoading) {
    article = (data || [])[0]
  }

  return (
    <div className="pb-10">
      <div
        className="bg-white py-7 px-12 flex items-center cursor-pointer"
        onClick={() => {
          push('/anleitung')
        }}
      >
        <ArrowLeft />
        <div className="ml-6">zurück</div>
      </div>
      {article && (
        <AppContainer>
          <h1 className={style.headline}>{article.title}</h1>
          <div className={style.content}>
            {article.article_media && (
              <div className="mb-8">
                <img
                  src={article.article_media.image.url}
                  alt={
                    article.article_media.alternative ||
                    article.article_media.image.alternativeText
                  }
                  title={article.article_media.title}
                />
                {article.article_media.caption && (
                  <p className="text-gray-manatee text-sm">
                    {article.article_media.caption}
                  </p>
                )}
              </div>
            )}
            <div className="grid gap-4">
              {article.content.map((c) => {
                if (c.image) {
                  return (
                    <div key={article.id + '-image-' + c.id}>
                      <img
                        src={c.image.url}
                        alt={c.alternative || c.image.alternativeText}
                        title={c.title}
                      />{' '}
                      {c.caption && (
                        <p className="text-gray-manatee text-sm">{c.caption}</p>
                      )}
                    </div>
                  )
                }
                if (c.code) {
                  return (
                    <div
                      key={article.id + '-code-' + c.id}
                      dangerouslySetInnerHTML={{
                        __html: c.code
                      }}
                    />
                  )
                }
                return (
                  <div key={article.id + '-content-' + c.id}>
                    <ReactMarkdown
                      rehypePlugins={[RehypeRaw]}
                      children={c.content}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </AppContainer>
      )}
    </div>
  )
})

export default InstructionDetailPage
